module.exports = __webpack_public_path__ + "static/bigcommerce_1-1feea3f6a328f776eaa405fe87d3568b.png";